module.exports = __webpack_public_path__ + "img/closeicon.2ff62aa3.svg";